import React from 'react';
import { motion } from 'framer-motion';
import { githubReposData } from '../data/contentData';

const REPO_STYLE = {
  1: { icon: '📦', colors: ['#7C3AED', '#4338CA'] }, //SCM
  2: { icon: '🌫️', colors: ['#0EA5E9', '#0369A1'] }, //Pm2.5
  3: { icon: '🪟', colors: ['#10B981', '#047857'] }, //portfolio - need to share this
  4: { icon: '📓', colors: ['#F59E0B', '#D97706'] }, // ml notebooks
};
const FALLBACK = { icon: '🐙', colors: ['#2b3137', '#1a1e22'] };

const GitHubView = () => {
  return (
    <div className="w-full min-h-full bg-pure-black">
      <div className="max-w-4xl mx-auto px-6 py-8 text-center">
        <h2 className="text-2xl font-bold text-pure-white mb-2">
          GitHub Repositories
        </h2>
        <p className="text-gray-400 text-sm">
          Curated projects from github.com/niccolopaganini
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-10 md:gap-14 px-6 pb-12">
        {githubReposData.map((repo, i) => {
          const style = REPO_STYLE[repo.id] || FALLBACK;
          return (
            <motion.a
              key={repo.id}
              data-testid="repo-tile"
              href={repo.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                delay: i * 0.06,
                type: 'spring',
                stiffness: 300,
                damping: 20,
              }}
              whileHover={{ scale: 1.12, y: -6 }}
              whileTap={{ scale: 0.88 }}
              className="flex flex-col items-center gap-2.5 group outline-none"
            >
              <div
                data-testid="tile-icon"
                className="w-16 h-16 md:w-[72px] md:h-[72px] rounded-[18px] md:rounded-[20px] flex items-center justify-center transition-shadow duration-300"
                style={{
                  backgroundImage: `linear-gradient(145deg, ${style.colors[0]}, ${style.colors[1]})`,
                  boxShadow: `0 4px 20px ${style.colors[0]}50, inset 0 1px 0 rgba(255,255,255,0.1)`,
                }}
              >
                <span className="text-3xl md:text-[34px] select-none">
                  {style.icon}
                </span>
              </div>
              <span
                data-testid="tile-label"
                className="text-[11px] text-gray-500 group-hover:text-pure-white transition-colors font-medium tracking-wide max-w-[88px] text-center truncate"
              >
                {repo.name}
              </span>
            </motion.a>
          );
        })}
      </div>
    </div>
  );
};

export default GitHubView;
